import { authenticationTypes } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { salesPredictionEndpointIds } from 'root/src/shared/salesPrediction/salesPrediction.constants';
export const getRevenuePredictionEndpoint = {
    [salesPredictionEndpointIds.GET_REVENUE_PREDICTION]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: AuthGroup.Admin,
        endpointType: otherEndpointType,
        payloadSchema: {
            type: 'object',
            properties: {
                launchPrice: { type: 'number', minimum: 1 },
                genres: {
                    type: 'array',
                    items: { type: 'string' },
                },
                wishlists: { type: 'integer', minimum: 1 },
                followers: { type: 'integer', minimum: 1 },
                quarterNo: { type: 'integer', enum: [1, 2, 3, 4] },
                isEarlyAccessRelease: { type: 'boolean' },
                hadEarlyAccessRelease: { type: 'boolean' },
                earlyAccessDurationDays: { type: 'integer', minimum: 1 },
            },
            required: ['launchPrice', 'genres', 'wishlists', 'followers', 'quarterNo'],
            additionalProperties: false,
        },
    },
};
